// removed by extract-text-webpack-plugin
module.exports = {"propertyNote":"_3jCvnzoTIq8mcURhp_7b8j"};


//////////////////
// WEBPACK FOOTER
// ./src/components/PropertyDetailedInfo/PropertyNote/PropertyNote.scss
// module id = 1738
// module chunks = 0